import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { motion } from "framer-motion";
import LaptopImage from '../images/Laptop.webp';
import { EXECUTIVE_PG_DEVOPS_PROGRAM } from "../../constants/AzureDevops";

export default function CollaborationMicrosoft(props) {
    const { isSmallScreen, course } = props;
    const fadeUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop:  course === EXECUTIVE_PG_DEVOPS_PROGRAM && ( isSmallScreen ? 4 : 8 ),
            }}
        >
            <Box sx={{ width: isSmallScreen ? "90%" : "70%", textAlign: "center" }}>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUp}
                >
                    <Typography
                        variant={isSmallScreen ? "h5" : "h4"}
                        sx={{
                            fontWeight: 700,
                            color: "#111",
                            fontFamily: "Poppins, sans-serif",
                            mb: 2,
                            textAlign: "left"
                        }}
                    >
                        In Collaboration with Microsoft
                    </Typography>
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUp}
                >
                    <Paper
                        elevation={3}
                        sx={{
                            width: "100%",
                            mb: 4,
                            overflow: "hidden",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true }}
                            variants={fadeUp}
                        >
                            <Typography
                                sx={{
                                    color: "#333",
                                    fontSize: "0.9rem",
                                    maxWidth: "900px",
                                    padding: "1rem",
                                    lineHeight: 1.6,
                                    fontFamily: "Poppins, sans-serif",
                                    textAlign: "left"
                                }}
                            >
                                Learn through a program shaped by Microsoft-certified experts, backed
                                by resources that follow global tech standards, giving your DevOps
                                career a trusted and competitive edge.
                            </Typography>
                        </motion.div>
                        <Typography sx={{ color: "white", fontFamily: "Poppins, sans-serif", float: "right", marginTop: "1rem" }}>
                            <img src={LaptopImage} width={"100%"} loading="lazy" alt={"Laptop Image"}/>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeUp}
                            >
                                <Button
                                    aria-label="Verify and Validate on Microsoft Marketplace"
                                    variant="contained"
                                    onClick={() => window.open("https://marketplace.microsoft.com/en-us/marketplace/partner-dir/2f6c32be-8a41-4258-8ae2-78eb0e92e44e/overview", "_blank")}
                                    sx={{
                                        backgroundColor: "#000",
                                        color: "#fff",
                                        px: 2,
                                        py: 1,
                                        textTransform: "none",
                                        fontSize: "0.9rem",
                                        fontWeight: "400",
                                        fontFamily: "Poppins, sans-serif",
                                        "&:hover": { backgroundColor: "#333" },
                                        margin: "0 2rem 2rem 2rem",
                                        float: "right"
                                    }}
                                >
                                    Click here to Verify & Validate
                                </Button>
                            </motion.div>
                        </Typography>
                    </Paper>
                </motion.div>
            </Box>
        </Box>
    );
}
